import styled, { createGlobalStyle, css } from 'styled-components';

import colors from './colors';

export const GlobalStyle = createGlobalStyle`
  /**
  * CLASSES UTILITÁRIAS
  * MARGEM
  * mt-x, mr-x, mb-x, ml-x
  * pt-x, pr-x, pb-x, pl-x
  */
   @font-family: Roboto;

  ${[0, 5, 10, 15, 20].map(
    size => css`
      ${['top', 'right', 'bottom', 'left'].map(
        dir => css`
          .m${dir[0]}-${size}{
            margin-${dir}: ${size}px;
          }
          .p${dir[0]}-${size}{
            padding-${dir}: ${size}px;
          }
        `
      )}
    `
  )}

  .ant-btn, .ant-picker {
    border-radius: 0;
  }

  .ant-btn-primary{
    background-color: #24A95D;
    border: none;
    &:hover {
    background: #24a95d;
    color: #fff;
    }
    &:focus {
      background-color: #24a95d;
      color: #fff;
    }
  }

  .ant-layout, .ant-layout-has-sider {
    background-color: #E5E5E5;
  }

  .ant-tooltip-inner {
    white-space: pre-line;
  }

  .skeleton-inicio {
    width: auto;
    padding: 50px;
    background-color: #fff;
    margin: 50px;
  }

  .ant-spin-white {
    .ant-spin-dot-item {
      background-color: white;
    }
  }

  .site-layout {
    margin: 0;
  }

  .ant-typography{
    white-space: nowrap;
  }

  h4.ant-typography {
    font-size: 18px;
  }

  .pull-right {
    float: right;
  }

  .pull-left {
    float: left;
  }

  body {
    font-family: Roboto;
    margin: 0;
    min-width: 320px;
  }

  #root {
    min-height: 100vh;
  }

  a,
  .ant-btn-link {
    color: rgb(36, 169, 93);
  }

  a:hover,
  .ant-btn-link:hover {
    color: rgb(30, 143, 78);
  }


  .ant-layout-header{
    background-color: #fff;
    padding: 0 32px;
    max-height: 65px;

    @media (max-width: 767px) {
      padding: 0 16px;
    }
  }

  .ant-form-vertical .ant-form-item-label{
    padding: 0;
  }

  .ant-form-large .ant-form-item-label > label{
    height: auto;
    padding-bottom: 5px;
  }

  .ant-form-item-explain{
    height: auto;
  }

  .ant-picker-large{
    border-radius: 2px;
  }

  .ant-input-number{
    width: 100%;
  }

  .ant-tooltip {
    max-width: 800px;
    white-space: pre;
  }

  .ant-table-tbody > tr.ant-table-row-selected > td,
  .ant-table-tbody > tr.ant-table-row-selected:hover > td {
    background: rgb(173 232 79 / 85%);
  }

  .ant-layout-sider-trigger {
    background: #01141b;
  }

  .ant-typography {
    white-space: normal !important;
  }

  .ant-switch-checked {
  background-color: #24A95D !important;
}

.ant-tabs, .ant-tabs-top, .ant-tabs-card {
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-nav-wrap {
      .ant-tabs-nav-list {
        margin-left: 24px;
        height: 30px;
        .ant-tabs-tab {
          background: ${colors.gbGrey};
          font-size: 14px;
          line-height: 22px;
          border-radius: 2px 2px 0px 0px !important;
          .ant-tabs-tab-btn {
              color: ${colors.verde};
            }
          }
          .ant-tabs-tab-active {
          background: ${colors.branco};
          border-top: 3px solid ${colors.verde};
          border-bottom-color: ${colors.branco};
          .ant-tabs-tab-btn {
              color: ${colors.greyText};
          }
      }
      }
    }
  }
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-content-holder {
    border-radius: 2px;
  }

  .ant-input {
    background: #f2f2f2;
  }
}
tr:nth-child(even) {
  background-color: #F2F2F2;
}

`;

export const AsteriscoObrigatorio = styled.span`
  color: #ff4d4f;
  float: left;
  padding-right: 4px;
`;
